import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["balloon", "button", "widget"]
  static values = { balloonTransitionDuration: { type: Number, default: 500 } }

  balloonDismissedStorageKey = "chat_widget_balloon_dismissed"

  balloonHideTimeout = null

  connect() {
    this.loadState()
  }

  loadState() {
    const isOpen = localStorage.getItem("chat_widget_open") === "true"
    if (isOpen) {
      this.openChat()
    } else {
      this.closeChat()
    }
  }

  dismissBalloon() {
    if (this.hasBalloonTarget) {
      this.hideBalloon()
    }

    localStorage.setItem(this.balloonDismissedStorageKey, "true")
  }

  toggle() {
    const isOpen = this.buttonTarget.getAttribute("data-chat-open") === "true"
    if (isOpen) {
      this.closeChat()
    } else {
      this.openChat()
    }
  }

  openChat() {
    this.buttonTarget.setAttribute("data-chat-open", "true")
    this.buttonTarget.classList.add("hidden")
    if (this.hasBalloonTarget) {
      this.hideBalloon()
      localStorage.setItem(this.balloonDismissedStorageKey, "true")
    }
    this.widgetTarget.classList.remove("hidden", "opacity-0", "scale-95")
    this.widgetTarget.classList.add("opacity-100", "scale-100")
    this.scrollConversationToBottom()
    localStorage.setItem("chat_widget_open", "true")
  }

  closeChat() {
    this.buttonTarget.setAttribute("data-chat-open", "false")
    this.buttonTarget.classList.remove("hidden")
    if (this.hasBalloonTarget) {
      if (this.isBalloonDismissed()) {
        this.hideBalloon()
      } else {
        this.showBalloon()
      }
    }
    this.widgetTarget.classList.add("hidden", "opacity-0", "scale-95")
    this.widgetTarget.classList.remove("opacity-100", "scale-100")
    localStorage.setItem("chat_widget_open", "false")
  }

  isBalloonDismissed() {
    return localStorage.getItem(this.balloonDismissedStorageKey) === "true"
  }

  showBalloon() {
    clearTimeout(this.balloonHideTimeout)
    this.balloonTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      this.balloonTarget.classList.remove("opacity-0", "translate-y-2", "scale-95")
      this.balloonTarget.classList.add("opacity-100", "translate-y-0", "scale-100")
    })
  }

  hideBalloon() {
    clearTimeout(this.balloonHideTimeout)
    this.balloonTarget.classList.add("opacity-0", "translate-y-2", "scale-95")
    this.balloonTarget.classList.remove("opacity-100", "translate-y-0", "scale-100")

    this.balloonHideTimeout = setTimeout(() => {
      if (this.hasBalloonTarget) {
        this.balloonTarget.classList.add("hidden")
      }
    }, this.balloonTransitionDurationValue)
  }

  scrollConversationToBottom() {
    requestAnimationFrame(() => {
      const conversationMessages = this.widgetTarget.querySelector("#conversation_messages")
      if (conversationMessages) {
        conversationMessages.scrollTop = conversationMessages.scrollHeight
      }
    })
  }

}
